import queryString from 'query-string';

// Constants
import ENV from 'constants/enviroments';

export const INTERMEDIATE_STOPS_QUERY_PARAM = 'intermediateStops';

/** Opção habilitada por cliente via REACT_APP_ENABLE_PMV_INTERMEDIATE_STOPS. */
export const isIntermediateStopsOptionEnabled = () =>
  ENV.ENABLE_PMV_INTERMEDIATE_STOPS === 'true';

/**
 * Query string anexada à URL pública do painel com a escolha do operador.
 * Vazia quando a opção está desabilitada, mantendo a URL como era antes.
 */
export const buildIntermediateStopsQuery = (
  showIntermediateStops: boolean,
): string => {
  if (!isIntermediateStopsOptionEnabled()) return '';
  return `?${INTERMEDIATE_STOPS_QUERY_PARAM}=${showIntermediateStops}`;
};

/**
 * Parâmetros extras do body do resume de itinerário, lidos da URL do painel.
 * "Exibir paradas intermediárias" marcado => ignoreIntermediate: false.
 * Desmarcado => ignoreIntermediate: true.
 * URL sem a opção => não envia nada (comportamento padrão do backend).
 */
export const getIgnoreIntermediateParam = (
  search: string,
): { ignoreIntermediate?: boolean } => {
  const value = queryString.parse(search)[INTERMEDIATE_STOPS_QUERY_PARAM];
  if (value === 'true') return { ignoreIntermediate: false };
  if (value === 'false') return { ignoreIntermediate: true };
  return {};
};

/** Mesmo encurtador usado no painel de metrô (BD-9659); o TinyURL passou a responder 422. */
const SHORTENER_ENDPOINT = 'https://da.gd/shorten';

/**
 * Encurta a URL pública do painel via da.gd (resposta em texto puro).
 * Deve ser chamada uma única vez, no clique em "Gerar URL", com os valores
 * finais dos campos. Se o encurtador falhar (rede, status diferente de 200,
 * resposta inesperada), devolve a própria URL longa, que funciona igual.
 */
export const shortenPanelUrl = async (url: string): Promise<string> => {
  try {
    const response = await fetch(
      `${SHORTENER_ENDPOINT}?url=${encodeURIComponent(url)}`,
      { method: 'GET' },
    );
    if (response.status !== 200) {
      throw new Error(`da.gd respondeu com status ${response.status}`);
    }
    const shortUrl = (await response.text()).trim();
    if (!/^https?:\/\//.test(shortUrl)) {
      throw new Error(`da.gd devolveu resposta inesperada: ${shortUrl}`);
    }
    return shortUrl;
  } catch (error) {
    console.error('Falha ao encurtar a URL do painel:', error);
    return url;
  }
};
